import React, {useState} from 'react';
import Nav from './Nav';
import Footer from './Footer';
import './home.css';
import './Sales.css';
import { Link,useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {IconButton} from '@mui/material';
import { MdKeyboardBackspace } from "react-icons/md";
import DataTable from 'react-data-table-component';
import { Buffer } from 'buffer';
import useFetch from '../Components/UseFetch';
import {salesQuotes as SQ} from '../HelperFx/datalinks';
import { addCommas } from '../HelperFx/common.js';


import verifyToken from '../HelperFx/verifyJwt.js';

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
  // //Console.log(username);
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;

const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;


const eq = ' eq ';
const filter = '&$filter =';
const formatDate = (dateString) => {
  if (!dateString) return "";
  const parts = dateString.split('-');
  if (parts.length === 3) {
    const year = parts[0];
    const month = parts[1].padStart(2, '0');
    const day = parts[2].padStart(2, '0'); 
    const date = new Date(`${month}/${day}/${year}`);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split('T')[0];
  }
  return "";
};


const CustTable = () => {

  // const token = Buffer.from(`HRP:HRPbc@2023`, 'utf8').toString('base64');
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
  // const token = Buffer.from(`HRP:HRPbc@2023`, 'utf8').toString('base64');
  const jwttoken = sessionStorage.getItem('authToken');
  const {custName, userName, userType,  password} = verifyToken(jwttoken);
  //Console.log(custName,userName, password);

  // const customerLink = `${process.env.REACT_APP_API_URL}${customers}`; // Replace with the actual API URL
  const { data: salesQuotes, loading, error } = useFetch(`${REACT_DATA_URL}${SQ}?${REACT_APP_COMPANY_URL}${filter}customerNo${eq}'${custName}'`, token);

  // const { data: customer, loading, error } = useFetch(customerLink, token);
  const salesQuoteInformation = salesQuotes?.value;
  //Console.log(salesQuoteInformation);


  const navigate = useNavigate();

  const data = salesQuoteInformation || [];

  const [searchTerm, setSearchTerm] = useState('');

  const columns = [
    { name: 'No.',
      selector: row =>
      (
        <span
          style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => navigate(`/PurchaseQuote`, {state: {number: row.number, id: row.id}})}>
          {row.number}
        </span> 
      ),
      sortable: true },
    { name: 'Customer No', selector: row => row.customerNo, sortable: true },
    { name: 'Created At', selector: row => formatDate(row.createdAt), sortable: true },
    { name: 'Customer Name', selector: row => row.customerName, sortable: true },
    { name: 'Currency', selector: row => row.currencyCode, sortable: true },
    { name: 'Amount', selector: row => addCommas(row.amount) || 0, sortable: true },
    { name: 'Processing Confirmed', selector: row => row.ConfirmProcessing, sortable: true },
  ];
  const filteredData = data.filter(item => 
    (item.number?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (item.customerNo?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (item.WorkDescription?.toLowerCase() || '').includes(searchTerm.toLowerCase())
  );
  console.log(filteredData);

  return (
    <div>
      {/* <h3>Purchase Quotes</h3> */}
      <input
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className='table-search'
      />

      <DataTable
        // title="Items List"
        columns={columns}
        data={filteredData}
        pagination
        customStyles={{
          rows: {
            style: {
              minHeight: '33px',
            },
          },
        }}
      />
    </div>
  );
};



const SalesQuotes = () => {
  return (
    <div className="Home">
      <Nav/>
      <div className="dash-main">
        <div className="squote">
          <div className="firsttab">
            <IconButton component={Link} to="/home">
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>
            <span>Purchase Quotes</span>
            {/* <div className="actions"> */}
              {/* <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" role="button" >Attach</a> */}
              {/* <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" >Print</a> */}
            {/* </div> */}
          </div>

          <div className="listTable">
            <CustTable/>

          </div>
        </div>
      </div>
      <Footer/>
  </div>
  )
}

export default SalesQuotes;